import {AcIsSet} from './ac-get-type-of';
import {AcClasses} from './ac-classes';

export class AcIndicator {
  constructor(
    $container,
    $indicator,
    routes,
    classNames,
    vertical = false,
    initial = null,
    withObserver = false
  ) {
    this.$container = $container.current;
    this.$indicator = $indicator.current;
    this.routes = routes;
    this.classNames = classNames;
    this.initial = initial;

    this.active = 0;

    this.observer = {
      instance: null,
      element: null,
    };

    this.vertical = vertical;
    this.start = vertical ? 'top' : 'left';
    this.end = vertical ? 'bottom' : 'right';

    this.last_direction = this.start;
    this.direction = this.start;
    this.position = vertical
      ? {top: 0, bottom: '100%'}
      : {
          left: 0,
          right: '100%',
        };

    this.Classes = new AcClasses();

    return this;
  }

  t = null;

  init = async () => {
    return await this.addEvents().then(() => {
      if (AcIsSet(this.initial) && this.initial) {
        const $initial = this.routes.find(route => {
          return route.id === this.initial;
        });

        if (AcIsSet($initial)) {
          setTimeout(() => this.recalculate(event, $initial), 300);
        }
      }
    });
  };

  handleResize = event => {
    if (this.t) clearTimeout(this.t);

    this.t = setTimeout(() => {
      window.requestAnimationFrame(() => {
        const $active = this.routes.find(item => item.index === this.active);
        if (AcIsSet($active)) this.recalculate(null, $active);
      });
    }, 1000 / 60);
  };

  addEvents = async () => {
    return await new Promise(resolve => {
      this.unload().then(() => {
        /* if (window.outerWidth > 768) {
          const $page = document.querySelector('#ac-scroller .ac-page');
          if (AcIsSet($page)) {
            this.observer.element = $page;
            this.observer.instance = new ResizeObserver(this.handleResize).observe($page);
            this.$indicator.setAttribute('data-observer', true);
          }
        } */

        let n = 0;
        let len = this.routes.length;

        for (n; n < len; n++) {
          const route = this.routes[n];

          if (!AcIsSet(route)) continue;

          if (route !== 'break') {
            route.index = n;

            if (AcIsSet(route.$ref)) {
              route.$ref.addEventListener(
                'click',
                event => {
                  this.recalculate(event, route);
                },
                {passive: true}
              );
            }
          }

          if (n === len - 1) resolve();
        }
      });
    });
  };

  unload = () => {
    if (AcIsSet(this.observer.instance) && AcIsSet(this.observer.instance.unobserve))
      this.observer.instance.unobserve(this.observer.element);

    return new Promise(resolve => {
      let n = 0;
      let len = this.routes.length;

      for (n; n < len; n++) {
        const route = this.routes[n];

        if (AcIsSet(route) && AcIsSet(route.$ref)) {
          route.$ref.removeEventListener(
            'click',
            event => {
              this.recalculate(event, route);
            },
            {passive: true}
          );
        }
      }

      resolve(this);
    });
  };

  update = (routes, orientation = null) => {
    return new Promise(resolve => {
      this.routes = routes;

      if (AcIsSet(orientation)) {
        this.vertical = orientation === 'vertical';

        this.start = this.vertical ? 'top' : 'left';
        this.end = this.vertical ? 'bottom' : 'right';

        this.last_direction = this.start;
        this.direction = this.start;
        this.position = this.vertical
          ? {top: 0, bottom: '100%'}
          : {
              left: 0,
              right: '100%',
            };

        if (this.$indicator) {
          this.$indicator.setAttribute('style', null);
        }
      }

      resolve();
    });
  };

  reset = () => {
    return this.unload().then(() => {
      this.active = 0;
      this.direction = this.start;
      this.position = this.vertical
        ? {top: 0, bottom: '100%'}
        : {
            left: 0,
            right: '100%',
          };

      this.move();
    });
  };

  recalculate = (event, route) => {
    if (!route) return;
    if (route.disabled) return;
    if (!route.$ref) return;
    // if (window.outerWidth <= 480) return;

    if (this.t) clearTimeout(this.t);

    this.t = setTimeout(() => {
      window.requestAnimationFrame(() => {
        if (!route.$ref) return;
        const offset = this.$container.getBoundingClientRect();
        const rect = route.$ref.getBoundingClientRect();

        const target = {
          [this.start]: rect[this.start] - offset[this.start],
          [this.end]: offset[this.end] - rect[this.end],
        };

        this.active = route.index;

        const direction =
          this.position[this.start] > target[this.start]
            ? this.start
            : this.position[this.start] < target[this.start]
            ? this.end
            : this.start;

        this.position[this.start] = target[this.start];
        this.position[this.end] = target[this.end];
        this.direction = direction;

        this.move();
      });
    }, 1000 / 60);
  };

  updateClasses = () => {
    return new Promise(resolve => {
      if (this.direction !== this.last_direction) {
        if (this.direction === this.start) {
          this.Classes.removeClass(this.$indicator, this.classNames.RIGHT);
          this.Classes.addClass(this.$indicator, this.classNames.LEFT);
        } else if (this.direction === this.end) {
          this.Classes.removeClass(this.$indicator, this.classNames.LEFT);
          this.Classes.addClass(this.$indicator, this.classNames.RIGHT);
        }
        this.last_direction = this.direction;
      }

      resolve();
    });
  };

  move = () => {
    if (!this.$indicator) return;

    this.updateClasses().then(() => {
      const start =
        this.position[this.start] === '100%'
          ? this.position[this.start]
          : `${this.position[this.start]}px`;

      const end =
        this.position[this.end] === '100%'
          ? this.position[this.end]
          : `${this.position[this.end]}px`;

      if (this.vertical) {
        this.$indicator.setAttribute('style', `top: ${start}; bottom: ${end}`);
      } else {
        this.$indicator.setAttribute('style', `left: ${start}; right: ${end}`);
      }
    });
  };
}
